<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">
                              Usuários
                            </h3>
                          </div>
                        </div>
                      </div>
                       <div class="text-right p-4">
                           <base-button :to="'/usuarios-proteticos/job'"  class="align-self-start" @click="aplicarFiltros()" :icon="'fas fa-plus'">Novo Usuário</base-button>
                       </div>
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                          <base-input class="mr-2 flex-grow-1" type="text" placeholder="nome" v-model="filtros.nome"></base-input>

                          <base-input class="mr-2 flex-grow-1">
                            <multiselect
                              v-model="filtros.status"
                              track-by="valor"
                              label="nome"
                              :options="status"
                              placeholder="por status"
                              :multiple="true"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os status</span>
                            </multiselect>
                          </base-input>
                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="usuariosList">
                            <template slot="columns">
                              <th>ID</th>
                              <th class="text-center">Laboratório</th>
                              <th>Nome Completo</th>
                               <th>E-mail</th>
                               <th>Último Acesso</th>
                              <th>Data de Criação</th>
                              <th></th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row">
                                <span>{{ row.id }}</span>
                              </th>
                              <th scope="row"  class="text-center">
                               {{ row.laboratorio.nomeFantasia }}
                              </th>
                              <td>
                                {{ row.nomeCompleto }}
                              </td>
                               <td>
                                {{ row.email }}
                              </td>
                                <td>
                                {{formatarData(row.last_acess)}}
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>
                              <td class="text-right">
                                  <base-button :to="'/usuarios-proteticos/job/' + row.id" type="default" icon="far fa-eye" size="sm" title="Visualizar usuário"></base-button>
                              </td>

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import usuarios from '@/cflow/proteticos.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  export default {
    name: 'tables',
    components: {
      Multiselect,
      BaseButton,
      BaseInput
    },
    methods: {
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;
          usuarios.listar({filtros: this.filtros}, 0, 0).then(res => {
            this.usuariosList = res;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(() => {
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped = this.skiped + this.usuariosList.length;
        this.initLoad(this.skiped);
      },
      initLoad: function(skipedLab, skipedDen) {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([usuarios.listar([],skipedLab, skipedDen)]).then( res => {
          this.usuariosList = this.usuariosList.concat(res[0]);
          this.loading = false;
         
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        skiped: 0,
        usuariosList:[],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            none: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.initLoad(0, 0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
</style>
